<template>
  <div :class="$style.root">
    <img :class="$style.bg" :src="bgImg" v-if="bgImg" />
    <div :class="$style.svg">
      <svg>
        <defs>
          <linearGradient id="thumb-mask-gradient" x2="0" y2="1">
            <stop offset="0" stop-color="white" stop-opacity="0" />
            <stop offset="45%" stop-color="white" stop-opacity="1" />
            <stop offset="55%" stop-color="white" stop-opacity="1" />
            <stop offset="100%" stop-color="white" stop-opacity="0" />
          </linearGradient>
          <mask id="thumb-mask">
            <rect width="100%" height="100%" fill="url(#thumb-mask-gradient)" />
          </mask>
        </defs>
        <rect width="100%" height="100%" :fill="bgColor" mask="url(#thumb-mask)" />
      </svg>
    </div>
    <div :class="$style.title">
      <slot></slot>
    </div>
  </div>
</template>

<script>
let hasMaskElem = false

export default {
  props: {
    bgImg: {
      type: String,
      default: null,
    },
    bgColor: {
      type: String,
      default: '#000000',
    },
  },
  data () {
    return {
      hasMaskElem: hasMaskElem,
    }
  },
  mounted () {
    hasMaskElem = true
  },
}
</script>

<style lang="scss" module>
.root {
  width: 210px;
  height: 160px;
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr;
  grid-template-areas: "one";
  @apply overflow-hidden;
  @apply rounded-lg;
  @apply text-black;
}

.bg,
.svg,
.title {
  grid-area: one;
}

.bg,
.svg {
  @apply w-full;
  @apply h-full;
}

.bg {
  @apply object-cover;
  @apply object-center;
}

.svg {
  > svg {
    @apply w-full;
    @apply h-full;
  }
}

.title {
  font-size: 2.5rem;
  @apply self-center;
  @apply text-center;
}
</style>
